import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Row, Col, FormGroup, Label, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import ToggleField from '../../ToggleField/ToggleField';

import logo from '../../../assets/images/integrations/cinech.png';

const CinechFields = () => {
    const { t }                  = useTranslation();
    const { isMobile, isTablet } = useSelector(state => state.ui);
    const { setting }            = useSelector(state => state.settings);

    return (
        <div className="CinechFields">
            {setting?.integrations?.cinech &&
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="small">
                                <img src={logo} className="img rounded" />
                                { t('settings.integrations.cinech.title') }
                            </CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.cinech.url")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name="integrations.cinech.url" id="url" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.cinech.cinema_ids")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name="integrations.cinech.cinema_ids" id="cinema_ids" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>

                        <CardBody>
                            <CardTitle className="small">{ t('settings.integrations.cinech.import.title') }</CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""}>{t("settings.integrations.cinech.import.screenings.title")}</Label>
                                            <Col lg={1} >
                                            <ToggleField name="integrations.cinech.import.screenings.enabled" />
                                            </Col>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.cinech.import.screenings.delete_future")}</Label>
                                            <Col lg={1} >
                                            <ToggleField name="integrations.cinech.import.screenings.delete_future" />
                                            </Col>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.cinech.import.screenings.delete_existing")}</Label>
                                            <Col lg={1} >
                                            <ToggleField name="integrations.cinech.import.screenings.delete_existing" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
}
        </div>
    );
}

export default CinechFields;
